import { FramerPage } from 'Pages/FramerPage';

const Startups = () => <FramerPage path="startups" />;

export default Startups;
